import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { withStyles } from '@mui/styles';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'var(--brand-primary)',

    fontWeight: '400',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  borderRadius: '10px 10px 0px 0px',
  '&:nth-of-type(odd)': {
    backgroundColor:
      'linear-gradient(0deg, #F9FAFC, #F9FAFC), linear-gradient(0deg, #F9FAFC, #F9FAFC), #F9FAFC,',
  },
}));

export const BgWhiteTooltip = withStyles({
  tooltip: {
    backgroundColor: '#ffffff',
    boxShadow: '0px 0px 4px 0px #00000040',
    padding: '10px',
  },
})(Tooltip);

export const styleimg = {
  display: 'flex',
  justifyContent: 'start', // Define the horizontal alignment
  alignItems: 'center',
};

export const stylename = {
  marginRight: '10px',
};

export const styleRatingMsg = {
  fontWeight: '500',
  marginLeft: '5px',
  fontSize: '16px',
};

export const styleRate = {
  fontWeight: '600',
  fontSize: '20px',
  marginLeft: '8px',
};

export const styleRating = {
  fontSize: '16px',
  fontWeight: '400',
  marginLeft: '5px',
};

export const selectOptionStyle = {
  maxHeight: '300px',
};
